var e={numberBadge:"lds-number-badge"};export{e as default};
